module.exports = __webpack_public_path__ + "images/profileicon.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/profileicon.png
// module id = /3L+
// module chunks = 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15